// extracted by mini-css-extract-plugin
module.exports = {"socialMediaContainer":"SocialMediaLinks_socialMediaContainer__e2_mK","socialMedia":"SocialMediaLinks_socialMedia__uI0Wk"};